var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBoxDiversified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    width: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.117 4.695v2.551l1.286.495v-2.52l2.25.925v8.7L.545 12.369V3.637zm10.285 7.673l-6.108 2.479v-8.7l6.108-2.51zM12.965 3.1l-5.99 2.462-2.26-.93L10.6 2.13zM9.093 1.51l-5.64 2.607L.982 3.1 6.973.637z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-box--diversified-ba61d585a630a7c2a7d21a34b7757e6c.svg";
export { SvgIconBoxDiversified as Component };